import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import axios from "axios";
import { toast } from "react-toastify";
import Select from "react-select";
import Swal from "sweetalert2";
import Loader from "../../shared/loader";
import Dropzone from "react-dropzone";
import { Watch } from "react-loader-spinner";

const AddSize = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [uploadData, setUploadData] = useState([]);
  const [isError, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dropFiles, setDropFiles] = useState([]);
  const [seriesName, setSeriesName] = useState("");

  const getSeriesName = () => {
    axios.post(API_URL.SERIES_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setSeriesName(res.data.data.name);
      }
    });
  };

  const getFiles = (files) => {
    const maxSize = 2 * 1024 * 1024;
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
    const invalidFiles = files.filter((file) => file.size > maxSize);
    const invalidTypeFiles = files.filter(
      (file) => !allowedTypes.includes(file.type)
    );
    if (invalidTypeFiles.length > 0) {
      toast.error("Only JPEG, JPG, and PNG files are allowed", {
        autoClose: 3000,
        position: "top-center",
      });
      return false;
    }
    if (invalidFiles.length > 0) {
      toast.error("Each file size must be less than 2 MB", {
        autoClose: 3000,
        position: "top-center",
      });
      return false;
    }


    if (
      (formValue.image_type === "LOGO" ||
        formValue.image_type === "SINGLE_PAGE" ||
        formValue.image_type === "SINGLE_WITHOUT_LOGO") &&
      files.length > 1
    ) {
      toast.error(
        "Only single file upload allowed for " + formValue.image_type,
        { autoClose: 3000, position: "top-center" }
      );
      return false;
    }

    setDropFiles(files);
    console.log(files);
  };
  // const getFiles = (files) => {
  //   if (
  //     (formValue.image_type == "LOGO" ||
  //       formValue.image_type == "SINGLE_PAGE" ||
  //       formValue.image_type == "SINGLE_WITHOUT_LOGO") &&
  //     files.length > 1
  //   ) {
  //     toast.error(
  //       "Only single file upload allowed for " + formValue.image_type,
  //       { autoClose: 3000, position: "top-center" }
  //     );
  //     return false;
  //   }

  //   setDropFiles(files);
  //   console.log(files);
  //   // files.forEach((file) => {
  //   //   const reader = new FileReader()
  //   //   reader.onabort = () => console.log('file reading was aborted')
  //   //   reader.onerror = () => console.log('file reading has failed')
  //   //   reader.onload = () => {
  //   //     const binaryStr = reader.result
  //   //     console.log(binaryStr)
  //   //   }
  //   //   reader.readAsArrayBuffer(file)
  //   // })
  // };

  const imageTypes = [
    {
      label: "SERIES_LOGO",
      value: "LOGO",
    },
    {
      label: "SINGLE_PAGE",
      value: "SINGLE_PAGE",
    },
    {
      label: "SINGLE_WITHOUT_LOGO",
      value: "SINGLE_WITHOUT_LOGO",
    },
    {
      label: "START_PAGE",
      value: "START_PAGE",
    },
    {
      label: "START_PAGE_WITHOUT_LOGO",
      value: "START_PAGE_WITHOUT_LOGO",
    },
    {
      label: "END_PAGE",
      value: "END_PAGE",
    },
    {
      label: "END_PAGE_WITHOUT_LOGO",
      value: "END_PAGE_WITHOUT_LOGO",
    },
  ];

  const [formValue, setFormValue] = useState({
    id: null,
    series_id: id,
    image_type: "",
    image: null,
  });

  const saveSize = () => {
    if (!formValue.name) {
      setLoading(true);
      var formData = new FormData();
      if (dropFiles) {
        for (let i = 0; i < dropFiles.length; i++) {
          formData.append("images[]", dropFiles[i]);
        }
      }
      formData.append("image_type", formValue.image_type);
      formData.append("series_id", formValue.series_id);
      axios.post(API_URL.SERIES_SAVE_IMAGE, formData).then((res) => {
        if (res.data.status === 1) {
          getImages();
          resetForm();
          toast.success("Saved", { autoClose: 3000, position: "top-center" });
        }
        setLoading(false);
      });
    }
  };

  const updateOrder = (imgId, series_id, page_number, k) => {
    let cpImageData = [...uploadData];
    cpImageData[k].page_number = page_number;
    setUploadData(cpImageData);
    if (!page_number) {
      return false;
    }
    axios
      .post(API_URL.SERIES_PAGE_NUMBER, {
        id: imgId,
        series_id: series_id,
        page_number: page_number,
      })
      .then((res) => {});
  };
  const isShowError = (value) => {
    if (
      isError &&
      (!value || value == "" || value == null || value == undefined)
    ) {
      return true;
    }
    return false;
  };

  const resetForm = () => {
    setFormValue({
      series_id: id,
      image_type: "",
      image: null,
    });
    // document.getElementById("imageSeries").value = null;
  };

  const getImages = () => {
    axios.post(API_URL.SERIES_IMAGES, { series_id: id }).then((res) => {
      if (res.data.status === 1) {
        setUploadData(res.data.data);
      }
      setLoading(false);
    });
  };

  const deleteImages = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + row.image_type,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.SERIES_DELETE_IMAGE, { id: row.id }).then((res) => {
          if (res.data.status === 1) {
            let newData = uploadData.filter((r) => r.id != row.id);
            setUploadData(newData);
          }
          toast.success("Delete Successfully", {
            autoClose: 3000,
            position: "top-center",
          });
          setLoading(false);
        });
      }
    });
  };

  const styles = {
    menu: (baseStyles, state) => ({
      ...baseStyles,
      marginTop: 2,
      zIndex: 999,
    }),
  };

  useEffect(() => {
    id && getImages();
    id && getSeriesName();
  }, [id]);

  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <h5>{seriesName} / Image Upload</h5>
          <div className="list-btn">
            <ul className="filter-list">
              <li>
                <Link to={"/admin/series"} className="btn btn-sm btn-secondary">
                  <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <form onSubmit={(event) => event.preventDefault()}>
            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label
                    className={`form-label ${
                      isShowError(formValue.image_type) && "required-field"
                    }`}
                  >
                    Image Type
                  </label>
                  <Select
                    options={imageTypes}
                    value={
                      imageTypes.find(
                        (r) => r.value === formValue.image_type
                      ) || null
                    }
                    styles={styles}
                    onChange={(e) => {
                      setDropFiles([]);
                      setFormValue({
                        ...formValue,
                        image_type: e.value || null,
                      });
                    }}
                  />
                </div>
              </div>
              <div className="col-md-12">
                {formValue.image_type && (
                  <div className="form-group">
                    <Dropzone
                      onDrop={(acceptedFiles) => getFiles(acceptedFiles)}
                      maxFiles={7}
                       accept="image/jpeg, image/jpg, image/png"
                    >
                      {({ getRootProps, getInputProps }) => (
                        <section>
                          <div {...getRootProps({ className: "dropzone" })}>
                            <input {...getInputProps()} />
                            <p>
                              Drag 'n' drop some files here, or click to select
                              files
                            </p>
                          </div>
                        </section>
                      )}
                    </Dropzone>
                    <aside>
                      <div style={{ display: "flex", marginTop: 30 }}>
                        {dropFiles.map((file, k) => (
                          <img
                            key={k}
                            src={URL.createObjectURL(file)}
                            alt={file.path}
                            style={{
                              width: "150px",
                              height: "150px",
                              marginRight: 10,
                            }}
                          />
                          
                        ))}
                      </div>
                    </aside>
                  </div>
                )}
              </div>
              {/* <div className="col-md-4">
                <div className="form-group">
                  <label>Image</label>
                  <input
                    type="file"
                    className="form-control"
                    id="imageSeries"
                    onChange={(event) => {
                      if (event.target.files) {
                        setFormValue({
                          ...formValue,
                          image: event.target.files[0],
                        });
                      } else {
                        setFormValue({ ...formValue, image: null });
                      }
                    }}
                  />
                </div>
              </div> */}
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="form-group text-end">
                <button
                  type="submit"
                  onClick={saveSize}
                  disabled={!dropFiles.length || !formValue.image_type}
                  className="btn btn-sm btn-primary"
                >
                  {loading ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Watch color={"white"} height={20} width={20} />
                    </div>
                  ) : (
                    "Save"
                  )}{" "}
                </button>
              </div>
            </div>
            <div className="d-flex justify-content-start" style={{color:"red"}}>The maximum limit of file size is 2MB</div>
          </form>
        </div>
      </div>
      {loading ? (
        <Loader></Loader>
      ) : (
        <div className="row">
          <div className="col-sm-12">
            <div className="card-table">
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-center table-hover datatable">
                    <thead className="thead-light">
                      <tr>
                        <th>#</th>
                        <th>Image Type</th>
                        <th>Number</th>
                        <th className="td-uplod">Image</th>
                        <th className="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {uploadData.map((row, key) => {
                        return (
                          <tr key={key}>
                            <td className="td-hash">{key + 1}</td>
                            <td>{row.image_type}</td>
                            <div>
                              {[
                                "START_PAGE",
                                "START_PAGE_WITHOUT_LOGO",
                                "END_PAGE",
                                "END_PAGE_WITHOUT_LOGO",
                              ].includes(row.image_type) && (
                                <td>
                                  <input
                                    type="number"
                                    value={row.page_number}
                                    placeholder="Enter number"
                                    className="form-control"
                                    onChange={(e) => {
                                      updateOrder(
                                        row.id,
                                        row.series_id,
                                        e.target.value,
                                        key
                                      );
                                    }}
                                  />
                                </td>
                              )}
                            </div>
                            <td className="td-uplod">
                              <div
                                style={{
                                  backgroundImage: "url(" + row.image + ")",
                                }}
                              ></div>
                            </td>
                            <td className="td-action">
                              <div>
                                <button
                                  onClick={() => deleteImages(row)}
                                  className="btn btn-sm btn-danger"
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddSize;
